export interface ChecklistMarkPoint {
  x: number;
  y: number;
}

export interface ChecklistMarkGesturePoint {
  x: number;
  y: number;
}

export const CHECKLIST_MARK_TAP_THRESHOLD = 10;
export const CHECKLIST_UNSAVED_MARKS_MESSAGE = 'Há marcações ainda não salvas. Salve ou descarte as marcações pendentes antes de continuar.';

export const normalizeChecklistMarkPoint = (
  x: number,
  y: number,
  width: number,
  height: number,
): ChecklistMarkPoint | null => {
  if (![x, y, width, height].every(Number.isFinite) || width <= 0 || height <= 0) return null;
  return {
    x: Math.max(0, Math.min(1, x / width)),
    y: Math.max(0, Math.min(1, y / height)),
  };
};

export const isChecklistMarkTap = (
  start: ChecklistMarkGesturePoint,
  end: ChecklistMarkGesturePoint,
  threshold = CHECKLIST_MARK_TAP_THRESHOLD,
): boolean => Math.hypot(end.x - start.x, end.y - start.y) <= threshold;

export const farthestChecklistMarkGesturePoint = (
  start: ChecklistMarkGesturePoint,
  furthest: ChecklistMarkGesturePoint,
  candidate: ChecklistMarkGesturePoint,
): ChecklistMarkGesturePoint => Math.hypot(candidate.x - start.x, candidate.y - start.y) >
  Math.hypot(furthest.x - start.x, furthest.y - start.y) ? candidate : furthest;

export const undoChecklistMark = <T,>(points: readonly T[]): T[] => points.slice(0, -1);
